export const PUBLISH_CURRENCY = process.env.GATSBY_PUBLISHING_CURRENCY || null
export const CURRENCY_ROUNDING_INCREMENTS = [25, 50, 75, 95, 125]
export const CURRENCY_EXCHANGE_TAX =
  parseFloat(process.env.GATSBY_EXCHANGE_TAX) || 0
